import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "cards",
  "use": "cards-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"cards\"><path fill-rule=\"evenodd\" clip-rule=\"evenodd\" d=\"M2 5.75C2 4.784 2.784 4 3.75 4h12.5c.966 0 1.75.784 1.75 1.75V8h2.25c.966 0 1.75.784 1.75 1.75v8.5A1.75 1.75 0 0120.25 20H7.75A1.75 1.75 0 016 18.25V16H3.75A1.75 1.75 0 012 14.25v-8.5zM7.5 16v2.25c0 .138.112.25.25.25h12.5a.25.25 0 00.25-.25v-8.5a.25.25 0 00-.25-.25H18v4.75A1.75 1.75 0 0116.25 16H7.5zM6 8.75A.75.75 0 016.75 8h1.5a.75.75 0 010 1.5h-1.5A.75.75 0 016 8.75z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol